import { z } from 'zod'
import i18n from '@/lib/i18n'

export const interacaoSchema = z.object({
	date: z.string().refine((val) => !Number.isNaN(Date.parse(val)), {
		message: i18n.t('form.interaction.dateError'),
	}),
	employeeId: z.uuid(i18n.t('form.interaction.employeeIdError')),
	leaderId: z.uuid(i18n.t('form.interaction.leaderIdError')),
	potential: z.string().optional(),
	classificationId: z.uuid(i18n.t('form.interaction.classificationError')),
	subclassificationId: z.uuid(
		i18n.t('form.interaction.subclassificationError'),
	),
	description: z.string().min(10, i18n.t('form.interaction.descriptionError')),
	action: z.string().min(1, i18n.t('form.interaction.actionError')),
})

// input (o que o form manda para o resolver)
export type InteracaoInput = z.input<typeof interacaoSchema>

// output (já coercido/validado; com Date)
export type InteracaoFormData = z.output<typeof interacaoSchema>
